// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const FactoryCodes = t.list(KeyValuePair, 'FactoryCodes');

export const getDefaultState = () => new FactoryCodes([]);

export default FactoryCodes;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/state/factory-codes.js